import React from 'react';
import {ReactSVG} from 'react-svg';
import {withRouter} from '@computerrock/formation-router';
import {connect} from 'react-redux';

import './SportIcon.scss';
import {kebabCase} from 'change-case';

const imageURL = sportId => {
    return sportId ? `${process.env.PUBLIC_URL}/assets/sports/${kebabCase(sportId)}.svg` : '/icons/sport.svg';
};

const SportIcon = ({sports, sportId}) => {
    if (!sports) return;

    const selectedSport = sports.find(sport => sport?.idNum == sportId);

    if (!selectedSport) return;

    const iconUrl = imageURL(selectedSport.id);

    return (
        <div className="sski-icon-sport" title={selectedSport.title}>
            <ReactSVG src={iconUrl} />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        sports: state.dashboard.sports,
    };
};

export default withRouter(connect(mapStateToProps)(SportIcon));
